import { render } from "./GridTabMeniuBilanturi.vue?vue&type=template&id=07d7b569"
import script from "./GridTabMeniuBilanturi.vue?vue&type=script&lang=js"
export * from "./GridTabMeniuBilanturi.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__